import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledPanel from '../../core/TitledPanel';
import Deprecated from '../../core/Deprecated';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import PrimaryButton from '../../core/PrimaryButton';
import SearchSelect from '../../core/SearchSelect';
import { globalStyles } from '../../core/style/gstheme';
import { getGraphFromProject } from '../../core/utils/utils';

const styles = Object.assign({}, globalStyles);

class FindClassDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang,
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let graph = this.props.projects.map(project => getGraphFromProject(project));
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: "http://www.w3.org/2002/07/owl#Class"
            }
        ];
        if (value !== "") {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                value: value,
                isExactMatch: false
            });
        }
        else {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label"
            });
        }
        let fullSearch =
        {
            search,
            graph,
            pageSize: 100,
            allowMissingResults: true,
            basicSort: true,
            exclude: ["http://www.w3.org/2002/07/owl#Thing", "http://www.w3.org/2002/07/owl#Nothing", ...this.props.exclude],
            language: lang,
            ignoreNoLanguage: lang !== "und",
            predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated"
            ],
            sort: "http://www.w3.org/2000/01/rdf-schema#label"
        };
        return fullSearch;
    };

    addClass = (id) => {
        // Check for incoming addition
        if (!this.props.exclude.includes(id)) {
            this.props.onAddClass(id);
        }
    };

    exitAddClass = () => this.setState({ open: false, lang: this.props.defaultLang });

    changeLanguage = (lang) => this.setState({ lang });

    render() {

        const { classes, exclude } = this.props;
        const { lang } = this.state;

        return (
            <React.Fragment>
                <AddButton dataTest="add-ontology-class" onClick={() => this.handleClickOpen()} title="Add classes" />
                <Dialog
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddClass}
                    aria-labelledby="find-class-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-class-dialog-title">Add Classes</DialogTitle>
                    <DialogContent style={{ height: 450, overflow: 'visible' }}>
                        <div style={{ height: 350 }}>
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.changeLanguage} />
                            </TitledPanel>
                            <SearchSelect
                                key={lang}
                                dataTest="find-class"
                                focus={true}
                                sortProp="label"
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSecondIcon={(result) => {
                                    if (result.deprecated) return <Deprecated />;
                                    return null;
                                }}
                                listDisplay={(result, lang) => {
                                    if (result.label[lang]) {
                                        return <Typography data-test="result-label" variant="body2">
                                            <Tooltip title={result.id}>
                                                <span>
                                                    {result.label[lang]}
                                                </span>
                                            </Tooltip>
                                        </Typography>;
                                    }
                                    else {
                                        return <Typography data-test="result-label" variant="body2">{result.id}</Typography>;
                                    }
                                }}
                                isClickableResult={(result) => !result.invalid && !result.deprecated}
                                exclude={exclude}
                                title="Filter classes"
                                lang={lang}
                                chosen={this.addClass} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <PrimaryButton onClick={this.exitAddClass}>Close</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindClassDialog.defaultProps = {
    exclude: []
};

FindClassDialog.propTypes = {
    classes: PropTypes.object,
    projects: PropTypes.array.isRequired,
    exclude: PropTypes.array,
    onAddClass: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(FindClassDialog);